export const sorts = ["За датою додавання", "А-Я", "Я-А"];
